import Home from '../PortfolioContainer/Home/Home'
import AboutMe from '../PortfolioContainer/AboutMe/AboutMe'
import Resume from '../PortfolioContainer/Resume/Resume'
import Testimonial from '../PortfolioContainer/Testimonials/Testimonials'
import Accolades from '../PortfolioContainer/Accolades/Accolades'
import ContactMe from '../PortfolioContainer/ContactMe/ContactMe'
import Projects from '../PortfolioContainer/Projects/Projects'
import Innovations from '../PortfolioContainer/Innovations/Innovations'

export const TOTAL_SCREENS = [
  {
    screen_name: "Home",
    component: Home
  },
  {
    screen_name: "About Me",
    component: AboutMe
  },
  {
    screen_name: "Résumé",
    component: Resume
  },
  {
    screen_name: "Projects",
    component: Projects
  },
  {
    screen_name: "Innovations",
    component: Innovations
  },
  {
    screen_name: "Testimonials",
    component: Testimonial
  },
  {
    screen_name: "Accolades",
    component: Accolades
  },
  {
    screen_name: "Contact Me",
    component: ContactMe
  }
]

export const GET_SCREEN_INDEX = (screen_name)=>{
  if(!screen_name) return -1;
  for(let i = 0; i < TOTAL_SCREENS.length; i++){
    if(TOTAL_SCREENS[i].screen_name === screen_name) return i;
  }
  return -1;
}